import React from 'react';

const LastEditorSave: React.FC = () => null;

export default LastEditorSave;
